import { saveInvoiceSystemConfig } from './invoicing-system-config';
import { saveCompany } from './company';
import { saveService } from './service';

export async function setupInvoicingSystemConfig(config, companies, services) {
  await saveInvoiceSystemConfig(config);
  await saveCompany(companies);
  await saveService(services);
}
